import axios from 'axios';
import Cookies from 'universal-cookie';

const cookies = new Cookies();
const API_URL = import.meta.env.VITE_API_URL_DASHBOARD_URL;

export const createFundraiser = async (fundraiserData, userId) => {
  const token = cookies.get('jwtToken');

  if (!token) {
    throw new Error('No JWT token found');
  }

  try {
    const response = await axios.post(
      `${API_URL}/fundraiser?user=${userId}`,
      fundraiserData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log('Response from API:', response);

    if (response.status !== 200 && response.status !== 201) {
      throw new Error('Failed to create fundraiser');
    }

    return response.data;
  } catch (error) {
    console.error('Error creating fundraiser:', error);
    throw error;
  }
};
